/**
 * Returns "percent" percent of "n".
 */
export default function percentOf(percent: number, n: number) {
    return n * (percent * 0.01);
}
